import { render, staticRenderFns } from "./ManageBlockages.vue?vue&type=template&id=02219096&scoped=true&"
import script from "./ManageBlockages.vue?vue&type=script&lang=js&"
export * from "./ManageBlockages.vue?vue&type=script&lang=js&"
import style0 from "./ManageBlockages.vue?vue&type=style&index=0&id=02219096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02219096",
  null
  
)

export default component.exports